<template>
  <a-drawer :title="title"
            :width="drawerWidth"
            @close="handleCancel"
            :visible="visible"
            :confirmLoading="confirmLoading">
    <div :style="{width: '100%',border: '1px solid #e9e9e9',padding: '10px 16px',background: '#fff',}">
      <a-spin :spinning="confirmLoading">
        <a-form :form="form">
          <mtc-form-item label="label.menuType" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-radio-group @change="onChangeMenuType" v-decorator="['menuType',{'initialValue':localMenuType}]">
              <a-radio :value="0">{{ $t('label.firstLevelMenu') }}</a-radio>
              <a-radio :value="1">{{ $t('label.submenu') }}</a-radio>
              <a-radio :value="2">{{ $t('label.buttonsPermissions') }}</a-radio>
            </a-radio-group>
          </mtc-form-item>
          <mtc-form-item :labelCol="labelCol"
                         :wrapperCol="wrapperCol"
                         :label="menuLabel"
                         hasFeedback>
            <a-input v-decorator="['name', validatorRules.name]"
                     :read-only="checkField('name')"
                     @click="openLangModal('name', true)"
                     :placeholder="$t('label.pleaseEnterMenuName')"/>
            <!-- <a-input placeholder="请输入菜单名称" v-decorator="[ 'name', validatorRules.name]" :readOnly="disableSubmit"/> -->
          </mtc-form-item>
          <mtc-form-item v-show="localMenuType!=0"
                         label="label.parentMenu"
                         :labelCol="labelCol"
                         :wrapperCol="wrapperCol"
                         :validate-status="validateStatus"
                         :hasFeedback="true"
                         :required="true">
            <span slot="help">{{ validateStatus == 'error'? $t('label.pleaseSelectParentMenu'): '&nbsp;&nbsp;' }}</span>
            <a-tree-select style="width:100%"
                           :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                           :treeData="treeData"
                           v-model="model.parentId"
                           :placeholder="$t('label.pleaseSelectParentMenu')"
                           :disabled="disableSubmit"
                           @change="handleParentIdChange">
            </a-tree-select>
          </mtc-form-item>
          <mtc-form-item :labelCol="labelCol"
                         :wrapperCol="wrapperCol"
                         label="label.menuPath">
            <a-input :placeholder="$t('label.pleaseEnterTheMenuPath')" v-decorator="[ 'url',validatorRules.url]" :readOnly="disableSubmit" />
          </mtc-form-item>
          <mtc-form-item v-show="show"
                         :labelCol="labelCol"
                         :wrapperCol="wrapperCol"
                         label="label.frontComponents">
            <a-input :placeholder="$t('label.pleaseEnterFrontComponents')" v-decorator="[ 'component',validatorRules.component]" :readOnly="disableSubmit" />
          </mtc-form-item>
          <mtc-form-item v-show="localMenuType==0"
                         :labelCol="labelCol"
                         :wrapperCol="wrapperCol"
                         label="label.defaultJumpAddress">
            <a-input :placeholder="$t('label.pleaseEnterRouterRedirect')" v-decorator="[ 'redirect',{}]" :readOnly="disableSubmit" />
          </mtc-form-item>
          <mtc-form-item v-show="!show"
                         :labelCol="labelCol"
                         :wrapperCol="wrapperCol"
                         label="label.authorizationID">
            <a-input :placeholder="$t('label.pleaseEnterAuthorization')" v-decorator="[ 'perms', {rules:[{ required: false, message: $t('tip.pleaseInput') },{validator: this.validatePerms }]}]"
                     :readOnly="disableSubmit" />
          </mtc-form-item>
          <mtc-form-item v-show="!show"
                         :labelCol="labelCol"
                         :wrapperCol="wrapperCol"
                         label="label.authorizationPolicy">
            <j-dict-select-tag v-decorator="['permsType', {}]" :placeholder="$t('label.pleaseSelectAuthorizationPolicy')" :type="'radio'" :triggerChange="true" dictCode="global_perms_type" />


          </mtc-form-item>
          <mtc-form-item v-show="!show"
                         :labelCol="labelCol"
                         :wrapperCol="wrapperCol"
                         label="label.status">
            <j-dict-select-tag v-decorator="['status', {}]" :placeholder="$t('label.pleaseSelectStatus')" :type="'radio'" :triggerChange="true" dictCode="valid_status" />

          </mtc-form-item>
          <mtc-form-item v-show="show"
                         :labelCol="labelCol"
                         :wrapperCol="wrapperCol"
                         label="label.menuIcon">
            <a-input :placeholder="$t('label.clickToSelectIcon')" v-model="model.icon" :readOnly="disableSubmit">
              <a-icon slot="addonAfter" type="setting" @click="selectIcons" />
            </a-input>
          </mtc-form-item>
          <mtc-form-item label="label.menuType" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <j-dict-select-tag type="list" v-decorator="['showType',validatorRules.showType]" :trigger-change="true" dictCode="show_type" :placeholder="$t('label.pleaseSelectMenuType')" />
          </mtc-form-item>
          <mtc-form-item v-show="show"
                         :labelCol="labelCol"
                         :wrapperCol="wrapperCol"
                         label="label.sort">
            <a-input-number :placeholder="$t('label.pleaseEnterMenuSort')" style="width: 200px" v-decorator="[ 'sortNo',validatorRules.sortNo]" :readOnly="disableSubmit" />
          </mtc-form-item>
          <mtc-form-item v-show="show"
                         :labelCol="labelCol"
                         :wrapperCol="wrapperCol"
                         label="label.IfRouteMenu">
            <a-switch :checkedChildren="$t('label.yes')" :unCheckedChildren="$t('label.no')" v-model="routeSwitch" />
          </mtc-form-item>
          <mtc-form-item v-show="show"
                         :labelCol="labelCol"
                         :wrapperCol="wrapperCol"
                         label="label.hideRouting">
            <a-switch :checkedChildren="$t('label.yes')" :unCheckedChildren="$t('label.no')" v-model="menuHidden" />
          </mtc-form-item>
          <mtc-form-item v-show="show"
                         :labelCol="labelCol"
                         :wrapperCol="wrapperCol"
                         label="label.ifCacheRoutes">
            <a-switch :checkedChildren="$t('label.yes')" :unCheckedChildren="$t('label.no')" v-model="isKeepalive" />
          </mtc-form-item>
          <mtc-form-item v-show="show"
                         :labelCol="labelCol"
                         :wrapperCol="wrapperCol"
                         label="label.aggregateRouting">
            <a-switch :checkedChildren="$t('label.yes')" :unCheckedChildren="$t('label.no')" v-model="alwaysShow" />
          </mtc-form-item>

           <mtc-form-item v-show="show"
                         :labelCol="labelCol"
                         :wrapperCol="wrapperCol"
                         label="label.baseFlag">
            <a-switch :checkedChildren="$t('label.yes')" :unCheckedChildren="$t('label.no')" v-model="baseFlag" />
          </mtc-form-item>
          <!--update_begin author:wuxianquan date:20190908 for:增加组件，外链打开方式可选 -->
          <mtc-form-item v-show="show"
                         :labelCol="labelCol"
                         :wrapperCol="wrapperCol"
                         label="label.openMethod">
            <a-switch :checkedChildren="$t('label.external')" :unCheckedChildren="$t('label.internal')" v-model="internalOrExternal" />
          </mtc-form-item>
          <!--update_end author:wuxianquan date:20190908 for:增加组件，外链打开方式可选 -->
        </a-form>
        <!-- 选择图标 -->
        <icons @choose="handleIconChoose" @close="handleIconCancel" :iconChooseVisible="iconChooseVisible"></icons>
      </a-spin>
      <a-row :style="{textAlign:'right'}">
        <a-button :style="{marginRight: '8px'}" @click="handleCancel">
          {{ $t('button.close') }}
        </a-button>
        <a-button :disabled="disableSubmit" @click="handleOk" type="primary">{{ $t('button.confirm') }}</a-button>
      </a-row>
    </div>
    <mtc-lang-modal />
  </a-drawer>
</template>

<script>
import { addPermission, editPermission, queryTreeList, duplicateCheck } from '@/api/api'
import Icons from './icon/Icons'
import pick from 'lodash.pick'
import { mtcLangModalMixin } from '@/mixins/mtcLangModalMixin'
import langInputMixin from '@/mixins/langInputMixin'
import { resetLangFieldMap, setLangInputParams } from '@/utils/langUtils'

export default {
  name: 'PermissionModal',
  mixins: [mtcLangModalMixin, langInputMixin],
  components: { Icons },
  data() {
    return {
      mainTable: 'sys_permission',
      drawerWidth: 700,
      treeData: [],
      treeValue: '0-0-4',
      title: '操作',
      visible: false,
      disableSubmit: false,
      model: {},
      localMenuType: 0,
      alwaysShow: false,//表单元素-聚合路由
      baseFlag: true,
      menuHidden: false,//表单元素-隐藏路由
      routeSwitch: true, //是否路由菜单
      /*update_begin author:wuxianquan date:20190908 for:定义变量，初始值代表内部打开*/
      internalOrExternal: false,//菜单打开方式
      /*update_end author:wuxianquan date:20190908 for:定义变量，初始值代表内部打开*/
      isKeepalive: true, //是否缓存路由
      show: true,//根据菜单类型，动态显示隐藏表单元素
      menuLabel: 'label.menuName',
      isRequrie: true,  // 是否需要验证
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },

      confirmLoading: false,
      // form: this.$form.createForm(this),

      iconChooseVisible: false,
      validateStatus: ''
    }
  },
  computed: {
    validatorRules: function() {
      return {
        name: { rules: [{ required: true, message: this.$t('label.pleaseEnterMenuName') }] },
        component: { rules: [{ required: this.show, message: this.$t('label.pleaseEnterFrontComponents') }] },
        url: { rules: [{ required: this.show, message: this.$t('label.pleaseEnterTheMenuPath') }] },
        permsType: { rules: [{ required: true, message: this.$t('label.pleaseSelectAuthorizationPolicy') }] },
        showType: { rules: [{ required: true, message: '请选择菜单类型!' }] },
        sortNo: { initialValue: 1.0 }
      }
    }
  },
  created() {
    this.initDictConfig()
  },
  methods: {
    loadTree() {
      var that = this
      queryTreeList().then((res) => {
        if (res.success) {
          console.log('----queryTreeList---')
          console.log(res)
          that.treeData = []
          let treeList = res.result.treeList
          for (let a = 0; a < treeList.length; a++) {
            let temp = treeList[ a ]
            temp.isLeaf = temp.leaf
            that.treeData.push(temp)
          }
        }
      })
    },
    add() {
      // 默认值
      this.edit({ status: '1', permsType: '1', route: true, baseFlag: true})
    },
    edit(record) {
      this.getLangForm(this.mainTable)
      this.resetScreenSize() // 调用此方法,根据屏幕宽度自适应调整抽屉的宽度
      this.form.resetFields()
      this.model = Object.assign({}, record)
      //--------------------------------------------------------------------------------------------------
      //根据菜单类型，动态展示页面字段
      console.log(record)
      this.baseFlag = !record.baseFlag? false: true
      this.alwaysShow = !record.alwaysShow? false: true
      this.menuHidden = !record.hidden? false: true
      if (record.route != null) {
        this.routeSwitch = record.route? true: false
      }
      if (record.keepAlive != null) {
        this.isKeepalive = record.keepAlive? true: false
      } else {
        this.isKeepalive = false // 升级兼容 如果没有（后台没有传过来、或者是新建）默认为false
      }
      /*update_begin author:wuxianquan date:20190908 for:编辑初始化数据*/
      if (record.internalOrExternal != null) {
        this.internalOrExternal = record.internalOrExternal? true: false
      } else {
        this.internalOrExternal = false
      }
      /*update_end author:wuxianquan date:20190908 for:编辑初始化数据*/
      //console.log('record.menuType', record.menuType);
      this.show = record.menuType == 2? false: true
      this.menuLabel = record.menuType == 2? 'label.buttonsPermissions': 'label.menuName'
      if (this.model.parentId) {
        this.localMenuType = 1
      } else {
        this.localMenuType = 0
      }
      //----------------------------------------------------------------------------------------------
      this.visible = true
      this.loadTree()
      let fieldsVal = pick(this.model, 'name', 'perms', 'permsType', 'component', 'redirect', 'url', 'sortNo', 'menuType', 'status', 'showType')
      this.$nextTick(() => {
        this.form.setFieldsValue(fieldsVal)
        this.$bus.$emit('mainlanguageLists', record.sysLanguageList)
      })
    },
    close() {
      this.$emit('close')
      this.disableSubmit = false
      this.visible = false
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          this.model.alwaysShow = this.alwaysShow
          this.model.baseFlag = this.baseFlag
          this.model.hidden = this.menuHidden
          this.model.route = this.routeSwitch
          this.model.keepAlive = this.isKeepalive
          /*update_begin author:wuxianquan date:20190908 for:获取值*/
          this.model.internalOrExternal = this.internalOrExternal
          /*update_end author:wuxianquan date:20190908 for:获取值*/
          let formData = Object.assign(this.model, values)
          if ((formData.menuType == 1 || formData.menuType == 2) && !formData.parentId) {
            that.validateStatus = 'error'
            that.$message.error('请检查你填的类型以及信息是否正确！')
            return
          } else {
            that.validateStatus = 'success'
          }
          // 设置数据多语言参数
          formData.sysLanguageList = setLangInputParams(this.mainTable, formData.id)
          console.log(formData)
          let url = addPermission
          if (!this.model.id) {
            url = addPermission
          } else {
            url = editPermission
          }
          that.confirmLoading = true
          url(formData).then(res => {
            if (res.success) {
              resetLangFieldMap()
              that.$message.success(res.message)
              that.$emit('ok')
            } else {
              that.$message.warning(res.message)
            }
          }).finally(() => {
            that.confirmLoading = false
            that.close()
          })
        }
      })
    },
    handleCancel() {
      this.close()
    },
    validateNumber(rule, value, callback) {
      if (!value || new RegExp(/^[0-9]*[1-9][0-9]*$/).test(value)) {
        callback()
      } else {
        callback('请输入正整数!')
      }
    },
    validatePerms(rule, value, callback) {
      if (value && value.length > 0) {
        //校验授权标识是否存在
        var params = {
          tableName: 'sys_permission',
          fieldName: 'perms',
          fieldVal: value,
          dataId: this.model.id
        }
        duplicateCheck(params).then((res) => {
          if (res.success) {
            callback()
          } else {
            callback('授权标识已存在!')
          }
        })
      } else {
        callback()
      }
    },
    onChangeMenuType(e) {
      //console.log('localMenuType checked', e.target.value)
      this.localMenuType = e.target.value
      if (e.target.value == 2) {
        this.show = false
        this.menuLabel = 'label.buttonsPermissions'
      } else {
        this.show = true
        this.menuLabel = 'label.menuName'
      }
      this.$nextTick(() => {
        this.form.validateFields(['url', 'component'], { force: true })
      })
    },
    selectIcons() {
      this.iconChooseVisible = true
    },
    handleIconCancel() {
      this.iconChooseVisible = false
    },
    handleIconChoose(value) {
      console.log(value)
      this.model.icon = value
      this.form.icon = value
      this.iconChooseVisible = false
    },
    // 根据屏幕变化,设置抽屉尺寸
    resetScreenSize() {
      let screenWidth = document.body.clientWidth
      if (screenWidth < 500) {
        this.drawerWidth = screenWidth
      } else {
        this.drawerWidth = 700
      }
    },
    initDictConfig() {
    },
    handleParentIdChange(value) {
      if (!value) {
        this.validateStatus = 'error'
      } else {
        this.validateStatus = 'success'
      }
    }
  }
}
</script>